// extracted by mini-css-extract-plugin
module.exports = {"inputPhoneContainer":"style-module--input-phone-container--3x-6D","inputPhoneInput":"style-module--input-phone-input--1lhyQ"};